import posthog from "posthog-js";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY ?? "";
const posthogUiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://us.posthog.com";

if (posthogKey && (posthog as { __loaded?: boolean }).__loaded !== true) {
  posthog.init(posthogKey, {
    api_host: "/ph",
    ui_host: posthogUiHost,
    defaults: "2025-11-30",
    capture_pageview: false,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true
    }
  });
}
